/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IKyberDmmRouter,
  IKyberDmmRouterInterface,
} from "../IKyberDmmRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "pools",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IKyberDmmRouter__factory {
  static readonly abi = _abi;
  static createInterface(): IKyberDmmRouterInterface {
    return new utils.Interface(_abi) as IKyberDmmRouterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IKyberDmmRouter {
    return new Contract(address, _abi, signerOrProvider) as IKyberDmmRouter;
  }
}
